/**
 * An API error
 */
export class ApiError extends Error {
  constructor(data) {
    super('An error has occurred.');
    this.data = data;
  }
}
